import { GeneralKind } from "./GeneralKind";

/** 府邸类 */
export namespace MansionKind {

     /** 通用数值 */  
     export enum GeneralValue {
        /** 朱清清id */
        ZHU_QING_QING = '1',
        /** 当铺老板的id */
        SHEN_NA_NA = '4',
        /** 侍寝需要达到的亲密度 */
        SERVANT_INTIMATE = 301,
        /** 派遣和出嫁最低阶段 */
        CHILD_MIN_STAGE_OPERATE = 3,
        /** 每天减亲密度 */
        WIFE_SUB_INTIMATE = 10,
        /** 每天减亲密度 */
        CHILD_SUB_INTIMATE = 5,
    }

    /** 建筑开启条件 */
    export enum BuildCondition {
        /** 建筑id达到多少级 */
        BUILD_REACH_LEVEL = 'build_reach_level',
        /** 府邸容量达到 */
        MANSION_VOLUME = 'mansion_volume',
        /** 拥有妻子数量 */
        OWN_WIFE = 'own_wife',
        /** 拥有子女数量 */
        OWN_CHILD = 'own_child',
        /** 娶妻 */
        MARRY_WIFE = 'marry_wife',
    }

    /** 妻子状态 */
    export enum WifeState {
        /** 不熟悉 */
        UNFAMILIAR = 1,
        /** 娶妻*/
        WIFE, 
        /** 抛弃 */
        CAST_AWAY, 
    }

    /** 卡牌类型 */
    export enum CardType {
        START = 0,
        /** 赠送 */
        GIVE = 1,
        /** 侍寝 */
        SERVANT,
        /** 教育 */
        EDUCATION,
        /** 取名 */ 
        NAME,
        /** 逐出 */ 
        REMOVE,
        /** 谈心 */ 
        CONSULT,
        /** 嫁出 */
        MARRY,
        /** 派遣 */
        DISPATCH,
        END,
    }

    // /** 妻子信息 */
    // export class WifeInfo {
    //     id: string;
    //     name: string;
    //     /** 迎娶触发的事件 */
    //     sEvent: string;
    // }

    // /** 妻子列表 */
    // export const WifeSelectList: WifeInfo[] = [
    //     { id: "1", name: "竹清清", sEvent: '31'},
    //     { id: "2", name: "百乐门掌柜", sEvent: '34'},
    //     { id: "3", name: "老妇人的孙女", sEvent: '33'},
    //     { id: "4", name: "当铺掌柜", sEvent: '35'},
    //     { id: "5", name: "皇妹", sEvent: '32'},
    //     { id: "6", name: "东夷女子", sEvent: '36'},
    // ];
    
}